import 'twin.macro';

const PrimaryButton = ({
  isSubmitting,
  text,
  otherStyle,
  type = 'submit',
  handelClick,
  ...res
}) => {
  return (
    <button
      type={type}
      onClick={handelClick}
      css={otherStyle}
      tw="py-[0.6em] px-[1.35em] rounded-[6px] border-[2px] border-[#8DA12B] bg-[#C6D86E]"
      {...res}
    >
      {isSubmitting ? 'Submitting...' : text}
    </button>
  );
};

export default PrimaryButton;
